module.exports = __webpack_public_path__ + "assets/HKNova-ExtraBold.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraBold.woff2
// module id = 118
// module chunks = 0